import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

// The height every page sits in.
//
// This replaces Wrapper, which computed `window.innerHeight - 75` ONCE at module
// load, outside the component, and handed the same frozen number to every screen
// for the life of the tab. Rotating the phone, or letting Safari's URL bar
// collapse, left every page sized for a viewport that no longer existed -- on
// Users that clipped the "Alter Password" button below the fold with nothing to
// scroll.
//
// `dvh` is the fix: the dynamic viewport unit already tracks the URL bar, so the
// browser keeps this correct without JavaScript hearing about it at all.
const NAV_HEIGHT = 65

export default function Page(props) {
    const { alignItems, title, actions, children } = props

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                // Left in the inline style rather than a class so the test can
                // prove it is an expression and not a measured pixel value.
                minHeight: 0
            }}
            style={{ height: `calc(100dvh - ${NAV_HEIGHT}px)` }}
        >
            {title && (
                <Box
                    sx={{
                        flex: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 2,
                        py: 1
                    }}
                >
                    <Typography variant='h6' sx={{ flex: 1, fontWeight: 300 }}>
                        {title}
                    </Typography>
                    {actions}
                </Box>
            )}

            <Container
                data-testid='page-body'
                sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    // The page owns its own scrolling. Previously the body did,
                    // which is why a container with a stale height could hide
                    // content instead of letting the user reach it.
                    overflowY: 'auto',
                    // Home-screen installs and notched phones: without this the
                    // last control sits under the gesture bar.
                    pb: 'env(safe-area-inset-bottom)',
                    alignItems: alignItems || null
                }}
            >
                {children}
            </Container>
        </Box>
    )
}
